import React, { useEffect, useState, useRef } from "react";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { InputMask } from "primereact/inputmask";
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";

export default function Panel_C({ data, setData, onUploadDialog, uploadPic, disabledPage }) {
    useEffect(() => {
        // console.log('data ',data);
    }, [data]); //searchData

    const onInputTextChange = (e, key) => {
        const type = (e.target && e.target.type) || "";
        const pattern = (e.target && e.target.pattern) || "";
        let val = (e.target && e.target.value) || "";

        if (pattern !== "") {
            val = val.replace(/\D/, "");
        }

        if (type === "checkbox") {
            if (e.checked)
                setData({
                    ...data,
                    [`${key}`]: val,
                });
            else
                setData({
                    ...data,
                    [`${key}`]: "N",
                });
        } else {
            setData({
                ...data,
                [`${key}`]: val,
            });
        }
    };

    const display_mode = () => {
        return data.displayMode === "Y" ? true : false;
    };

    const beforeInspectOptions = [
        { label: "ตรงตามแบบก่อสร้าง", value: "1" },
        { label: "ไม่ตรงตามแบบก่อสร้าง", value: "2" },
        { label: "ไม่ได้ตรวจ", value: "3" },
    ];

    const beforePumpOptions = [
        { label: "มี", value: "1" },
        { label: "ไม่มี", value: "2" },
    ];

    const beforeBoundaryFenceOptions = [
        { label: "มีครบ", value: "1" },
        { label: "ไม่มี", value: "2" },
        { label: "มีแต่ไม่ครบชุด", value: "3" },
    ];

    const duringPumpResultOptions = [
        { label: "ใช้งานได้", value: "1" },
        { label: "ใช้งานไม่ได้", value: "2" },
    ];

    const duringBoundaryFenceOptions = [
        { label: "มีครบ", value: "1" },
        { label: "ไม่มี", value: "2" },
        { label: "มีแต่ไม่ครบชุด", value: "3" },
    ];

    const approveFlagOptions = [
        { label: "อนุมัติให้ดำเนินการ", value: "1" },
        { label: "ไม่อนุมัติให้ดำเนินการ", value: "2" },
    ];


    return (
        <div>
            <div className="p-grid  p-fluid">
                <div className="p-col-12 p-md-12">
                    <h5>
                        <b>งานตรวจสอบงานตัดบรรจบ</b>
                    </h5>
                </div>
                <div className="p-col-12 p-md-6">
                    <h5 className="p-no-box line-under">
                        <b>ก่อนวันตัดบรรจบ</b>
                    </h5>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="checkOption1">ตรวจสอบแนวท่อประปาเดิม</label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="p-field-checkbox">
                                <Checkbox disabled={disabledPage} inputId="beforeGisCheckbox" name="beforeGisCheckbox" value="Y" checked={data.beforeGisCheckbox === "Y"} onChange={(e) => onInputTextChange(e, "beforeGisCheckbox")} />
                                <label htmlFor="beforeGisCheckbox">GIS</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="p-field-checkbox">
                                <Checkbox disabled={disabledPage} inputId="beforeAsBuiltCheckbox" name="beforeAsBuiltCheckbox" value="Y" checked={data.beforeAsBuiltCheckbox === "Y"} onChange={(e) => onInputTextChange(e, "beforeAsBuiltCheckbox")} />
                                <label htmlFor="beforeAsBuiltCheckbox">As - Built Drawing</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3"></div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="checkOption1">ผลการตรวจสอบ</label>
                        </div>
                        <div className="p-col-12 p-md-8">
                            <div className="flex justify-content-center">
                                <SelectButton optionLabel="label"
                                    options={beforeInspectOptions}
                                    value={data.beforeInspectResult}
                                    onChange={(e) => onInputTextChange(e, "beforeInspectResult")}
                                    optionValue="value"

                                />
                            </div>
                            {/* <div className="p-field-radiobutton">
                                <RadioButton
                                    disabled={disabledPage}
                                    inputId="beforeInspectResult_1"
                                    name="beforeInspectResult"
                                    id="beforeInspectResult_1"
                                    value="1"
                                    key="beforeInspectResult_1"
                                    checked={data.beforeInspectResult === "1" ? true : false}
                                    onChange={(e) => onInputTextChange(e, "beforeInspectResult")}
                                />
                                <label htmlFor="beforeInspectResult_1">ตรงตามแบบก่อสร้าง</label>
                            </div> */}
                        </div>
                        {/* <div className="p-col-12 p-md-3">
                            <div className="p-field-radiobutton">
                                <RadioButton
                                    disabled={disabledPage}
                                    inputId="beforeInspectResult_2"
                                    name="beforeInspectResult"
                                    id="beforeInspectResult_2"
                                    value="2"
                                    key="beforeInspectResult_2"
                                    checked={data.beforeInspectResult === "2" ? true : false}
                                    onChange={(e) => onInputTextChange(e, "beforeInspectResult")}
                                />
                                <label htmlFor="beforeInspectResult_2">ไม่ตรงตามแบบก่อสร้าง</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="p-field-radiobutton">
                                <RadioButton
                                    disabled={disabledPage}
                                    inputId="beforeInspectResult_3"
                                    name="beforeInspectResult"
                                    id="beforeInspectResult_3"
                                    value="3"
                                    key="beforeInspectResult_3"
                                    checked={data.beforeInspectResult === "3" ? true : false}
                                    onChange={(e) => onInputTextChange(e, "beforeInspectResult")}
                                />
                                <label htmlFor="beforeInspectResult_3">ไม่ได้ตรวจ</label>
                            </div>
                        </div> */}
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="p-field-radiobutton">- เครื่องสูบน้ำ จำนวน</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <div className="p-field-checkbox">
                                {/* <label htmlFor="checkOption1">จำนวน</label> */}
                                <InputText disabled={disabledPage} placeholder="จำนวน เครื่องสูบน้ำ" id="beforePumpCount" type="text" style={{ width: 150 }} value={data.beforePumpCount} maxLength="3" pattern="/\D/" onChange={(e) => onInputTextChange(e, "beforePumpCount")} />
                                <label htmlFor="checkOption1">เครื่อง</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-5">
                            <div className="p-grid">
                                <div className="p-col-12">
                                    <div className="flex justify-content-center">
                                        <SelectButton optionLabel="label"
                                            options={beforePumpOptions}
                                            value={data.beforePumpResult}
                                            onChange={(e) => onInputTextChange(e, "beforePumpResult")}
                                            optionValue="value"


                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton
                                            disabled={disabledPage}
                                            inputId="beforePumpResult_1"
                                            name="beforePumpResult"
                                            id="beforePumpResult_1"
                                            value="1"
                                            key="beforePumpResult_1"
                                            checked={data.beforePumpResult === "1" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "beforePumpResult")}
                                        />
                                        <label htmlFor="beforePumpResult_1">มี</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-6">
                                    <div className="p-field-radiobutton">
                                        <RadioButton
                                            disabled={disabledPage}
                                            inputId="beforePumpResult_2"
                                            name="beforePumpResult"
                                            id="beforePumpResult_2"
                                            value="2"
                                            key="beforePumpResult_2"
                                            checked={data.beforePumpResult === "2" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "beforePumpResult")}
                                        />
                                        <label htmlFor="beforePumpResult_2">ไม่มี</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.beforePumpResult !== "0" && data.beforePumpResult !== undefined && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T301")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.beforePumpResult !== "0" && data.beforePumpResult !== undefined ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T301")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}
                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" onClick={() => onUploadDialog("T301")} /> */}
                        </div>
                        {/* <div className="p-col-12 p-md-1">
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T301")} />
                        </div> */}
                        <div className="p-col-12 p-md-1"></div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="p-field-radiobutton">- ป้ายล้อมหลุม จำนวน</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <div className="p-field-checkbox">
                                {/* <label htmlFor="checkOption1">จำนวน</label> */}
                                <InputText
                                    disabled={disabledPage}
                                    placeholder="จำนวน ป้ายล้อมหลุม"
                                    id="beforeBoundaryFenceCount"
                                    type="text"
                                    style={{ width: 150 }}
                                    value={data.beforeBoundaryFenceCount}
                                    maxLength="3"
                                    pattern="/\D/"
                                    onChange={(e) => onInputTextChange(e, "beforeBoundaryFenceCount")}
                                />
                                <label htmlFor="checkOption1">ชุด</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-5">
                            <div className="p-grid">
                                <div className="p-col-12">
                                    <div className="flex justify-content-center">
                                        <SelectButton optionLabel="label"
                                            options={beforeBoundaryFenceOptions}
                                            value={data.beforeBoundaryFenceResult}
                                            onChange={(e) => onInputTextChange(e, "beforeBoundaryFenceResult")}
                                            optionValue="value"

                                            disabled={disabledPage}
                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="beforeBoundaryFenceResult_1"
                                            name="beforeBoundaryFenceResult"
                                            id="beforePumpResult_1"
                                            value="1"
                                            key="beforePumpResult_1"
                                            checked={data.beforeBoundaryFenceResult === "1" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "beforeBoundaryFenceResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="option1">มีครบ</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-6">
                                    <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="beforeBoundaryFenceResult_2"
                                            name="beforeBoundaryFenceResult"
                                            id="beforeBoundaryFenceResult_2"
                                            value="2"
                                            key="beforeBoundaryFenceResult_2"
                                            checked={data.beforeBoundaryFenceResult === "2" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "beforeBoundaryFenceResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="option2">ไม่มี</label>
                                    </div>
                                </div> */}
                            </div>
                            {/* <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="beforeBoundaryFenceResult_3"
                                            name="beforeBoundaryFenceResult"
                                            id="beforeBoundaryFenceResult_3"
                                            value="3"
                                            key="beforeBoundaryFenceResult_3"
                                            checked={data.beforeBoundaryFenceResult === "3" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "beforeBoundaryFenceResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="option1">มีแต่ไม่ครบชุด</label>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.beforeBoundaryFenceResult !== "0" && data.beforeBoundaryFenceResult !== undefined && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T302")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.beforeBoundaryFenceResult !== "0" && data.beforeBoundaryFenceResult !== undefined ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T302")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}

                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" onClick={() => onUploadDialog("T302")} /> */}
                        </div>
                        {/* <div className="p-col-12 p-md-1">
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T302")} />
                        </div> */}
                        <div className="p-col-12 p-md-1"></div>
                    </div>
                </div>
                <div className="p-col-12 p-md-6">
                    <h5 className="p-no-box line-under">
                        <b>วันตัดบรรจบ</b>
                    </h5>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="p-field-radiobutton">- เครื่องสูบน้ำ จำนวน</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <div className="p-field-checkbox">
                                {/* <label htmlFor="checkOption1">จำนวน</label> */}
                                <InputText disabled={disabledPage} placeholder="จำนวน เครื่องสูบน้ำ" id="duringPumpCount" type="text" style={{ width: 150 }} value={data.duringPumpCount} maxLength="3" pattern="/\D/" onChange={(e) => onInputTextChange(e, "duringPumpCount")} />
                                <label htmlFor="duringPumpCount">เครื่อง</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-5">
                            <div className="p-grid">
                                <div className="p-col-12">
                                    <div className="flex justify-content-center">
                                        <SelectButton optionLabel="label"
                                            options={duringPumpResultOptions}
                                            value={data.duringPumpResult}
                                            onChange={(e) => onInputTextChange(e, "duringPumpResult")}
                                            optionValue="value"


                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton
                                            disabled={disabledPage}
                                            inputId="duringPumpResult_1"
                                            name="duringPumpResult"
                                            id="duringPumpResult_1"
                                            value="1"
                                            key="duringPumpResult_1"
                                            checked={data.duringPumpResult === "1" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "duringPumpResult")}
                                        />
                                        <label htmlFor="duringPumpResult_1">ใช้งานได้</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-6">
                                    <div className="p-field-radiobutton">
                                        <RadioButton
                                            disabled={disabledPage}
                                            inputId="duringPumpResult_2"
                                            name="duringPumpResult"
                                            id="duringPumpResult_2"
                                            value="2"
                                            key="duringPumpResult_2"
                                            checked={data.duringPumpResult === "2" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "duringPumpResult")}
                                        />
                                        <label htmlFor="duringPumpResult_2">ใช้งานไม่ได้</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.duringPumpResult !== "0" && data.duringPumpResult !== undefined && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T311")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.duringPumpResult !== "0" && data.duringPumpResult !== undefined ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T311")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}

                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" onClick={() => onUploadDialog("T311")} /> */}
                        </div>
                        {/* <div className="p-col-12 p-md-1">
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T311")} />
                        </div> */}
                        <div className="p-col-12 p-md-1"></div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="p-field-radiobutton">- ป้ายล้อมหลุม จำนวน</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <div className="p-field-checkbox">
                                <InputText
                                    disabled={disabledPage}
                                    placeholder="จำนวน ป้ายล้อมหลุม"
                                    id="duringBoundaryFenceCount"
                                    type="text"
                                    style={{ width: 150 }}
                                    value={data.duringBoundaryFenceCount}
                                    maxLength="3"
                                    pattern="/\D/"
                                    onChange={(e) => onInputTextChange(e, "duringBoundaryFenceCount")}
                                />
                                <label htmlFor="duringBoundaryFenceCount">ชุด</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-5">
                            <div className="p-grid">
                                <div className="p-col-12">
                                    <div className="flex justify-content-center">
                                        <SelectButton optionLabel="label"
                                            options={duringBoundaryFenceOptions}
                                            value={data.duringBoundaryFenceResult}
                                            onChange={(e) => onInputTextChange(e, "duringBoundaryFenceResult")}
                                            optionValue="value"
                                            disabled={disabledPage}

                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton
                                            i
                                            inputId="duringBoundaryFenceResult_1"
                                            name="duringBoundaryFenceResult"
                                            id="duringBoundaryFenceResult_1"
                                            value="1"
                                            key="duringBoundaryFenceResult_1"
                                            checked={data.duringBoundaryFenceResult === "1" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "duringBoundaryFenceResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="duringBoundaryFenceResult_1">มีครบ</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-6">
                                    <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="duringBoundaryFenceResult_2"
                                            name="duringBoundaryFenceResult"
                                            id="duringBoundaryFenceResult_2"
                                            value="2"
                                            key="duringBoundaryFenceResult_2"
                                            checked={data.duringBoundaryFenceResult === "2" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "duringBoundaryFenceResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="duringBoundaryFenceResult_2">ไม่มี</label>
                                    </div>
                                </div> */}
                            </div>
                            {/* <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="duringBoundaryFenceResult_3"
                                            name="duringBoundaryFenceResult"
                                            id="duringBoundaryFenceResult_3"
                                            value="3"
                                            key="duringBoundaryFenceResult_3"
                                            checked={data.duringBoundaryFenceResult === "3" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "duringBoundaryFenceResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="duringBoundaryFenceResult_3">มีแต่ไม่ครบชุด</label>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.duringBoundaryFenceResult !== "0" && data.duringBoundaryFenceResult !== undefined && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T312")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.duringBoundaryFenceResult !== "0" && data.duringBoundaryFenceResult !== undefined ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T312")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}

                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" onClick={() => onUploadDialog("T312")} /> */}
                        </div>
                        {/* <div className="p-col-12 p-md-1">
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T312")} />
                        </div> */}
                        <div className="p-col-12 p-md-1"></div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="p-field-radiobutton">- รถขุด จำนวน</label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <div className="p-field-checkbox">
                                <InputText disabled={disabledPage} placeholder="จำนวน รถขุด" id="duringBackhoeCount" type="text" style={{ width: 150 }} value={data.duringBackhoeCount} maxLength="3" pattern="/\D/" onChange={(e) => onInputTextChange(e, "duringBackhoeCount")} />
                                {/* <InputMask
                                    id="duringBackhoeCount" type="text" style={{width:150}}
                                    value={data.duringBackhoeCount}
                                    onChange={(e) => onInputTextChange(e, 'duringBackhoeCount')}
                                    mask="99"

                                /> */}
                                <label htmlFor="duringBackhoeCount">คัน</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-4"></div>
                        <div className="p-col-12 p-md-2">
                            <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T313")} />
                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" alt="รูป จำนวนรถขุด " onClick={() => onUploadDialog("T313")} /> */}
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T313")} />
                        </div>
                        {/* <div className="p-col-12 p-md-1">
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T313")} />
                        </div> */}
                        <div className="p-col-12 p-md-1"></div>
                    </div>

                    <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="p-field-radiobutton">- เวลาปิด/เปิดน้ำ</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <label htmlFor="closeValveTime">เริ่มปิดน้ำเวลา</label>
                            <span style={{ color: "red" }}>*</span>
                            <span className="p-input-icon-right">
                                <InputMask disabled={disabledPage} id="closeValveTime" value={data.closeValveTime} onChange={(e) => onInputTextChange(e, "closeValveTime")} mask="99:99" />
                                <i className="pi pi-clock" />
                            </span>
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-4">
                            <label htmlFor="openValveTime">เปิดน้ำเวลา</label>
                            <span style={{ color: "red" }}>*</span>
                            <span className="p-input-icon-right">
                                <InputMask disabled={disabledPage} id="openValveTime" value={data.openValveTime} onChange={(e) => onInputTextChange(e, "openValveTime")} mask="99:99" />
                                <i className="pi pi-clock" />
                            </span>
                        </div>
                    </div>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-6">
                        <div className="flex justify-content-center">
                                <SelectButton optionLabel="label" 
                                options={approveFlagOptions} 
                                value={data.approveFlag} 
                                onChange={(e) => onInputTextChange(e, "approveFlag")}
                                optionValue="value" 
                                disabled={disabledPage}
                               
                                />
                                </div>
                            {/* <div className="p-field-radiobutton">
                                <RadioButton disabled={disabledPage} inputId="approveFlag" name="approveFlag" id="approveFlag" value="1" key="approveFlag" checked={data.approveFlag === "1" ? true : false} onChange={(e) => onInputTextChange(e, "approveFlag")} />
                                <label htmlFor="beforeInspectResult_1">อนุมัติให้ดำเนินการ</label>
                            </div> */}
                        </div>
                        {/* <div className="p-col-12 p-md-3">
                            <div className="p-field-radiobutton">
                                <RadioButton disabled={disabledPage} inputId="approveFlag" name="approveFlag" id="approveFlag" value="2" key="approveFlag" checked={data.approveFlag === "2" ? true : false} onChange={(e) => onInputTextChange(e, "approveFlag")} />
                                <label htmlFor="beforeInspectResult_2">ไม่อนุมัติให้ดำเนินการ</label>
                            </div>
                        </div> */}
                        
                    </div>
                    <div className="p-col-12 p-md-1"></div>
                    <div className="p-grid p-fluid">
                        <InputTextarea id="approveReason" rows={3} cols={30} value={data.approveReason} onChange={(e) => onInputTextChange(e, "approveReason")}></InputTextarea>
                        {/* <InputText disabled={disabledPage} placeholder="จำนวน รถขุด" id="duringBackhoeCount" type="text" style={{ width: 150 }} value={data.duringBackhoeCount} maxLength="3" pattern="/\D/" onChange={(e) => onInputTextChange(e, "duringBackhoeCount")} /> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
